import React from 'react';
import {
  Grid,
  Paper,
  Typography,
  Box,
  Container,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { LoginForm } from '../components/authentication/login';

const backImage = `${process.env.PUBLIC_URL}/images/back.jpg`;

const BackgroundImage = styled(Box)(({ theme }) => ({
  backgroundImage: `url(${backImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '100vh',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'rgba(0, 100, 100, 0.4)', // 藍綠色遮罩
  }
}));

const LoginContainer = styled(Paper)(({ theme }) => ({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.paper,
  boxShadow: 'none', // 移除外層陰影
}));

export default function LoginPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      {!isMobile && (
        <Grid item md={7} component={BackgroundImage}>
          <Box
            sx={{
              position: 'relative',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              alignItems: 'center',
              color: 'white',
              textAlign: 'center',
              zIndex: 1,
              pb: 5,
            }}
          >
            <Typography variant="h3" component="h2" gutterBottom>
              智慧城市，美好未來
            </Typography>
            <Typography variant="h6">
              連接、效率、永續
            </Typography>
          </Box>
        </Grid>
      )}
      <Grid item xs={12} md={5} component={LoginContainer} square>
        <Container maxWidth="sm" sx={{ // 從 'xs' 改為 'sm' 以增加寬度
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white',
          padding: theme.spacing(4, 6), // 增加內邊距
          borderRadius: '10px', // 調整為較小的圓角
          boxShadow: '0 3px 10px rgba(0, 0, 0, 0.2)', // 自定義陰影
        }}>
          <Box>
            <Typography component="h1" variant="h4" gutterBottom align="center">
              智慧城市移動資訊平台
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" align="center" sx={{ mb: 4 }}>
              請登入以繼續
            </Typography>
          </Box>
          <LoginForm />
          <Box sx={{ mt: 4 }}>
            <Typography variant="body2" color="text.secondary" align="center">
              © 2024 財團法人資策會
            </Typography>
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
}